import { c as _c } from "react/compiler-runtime";
import Badge, { BadgeProps } from '../../../../common/base/Badge';
export const tooltip_status = (resource_name: 'source' | 'destination' | 'connection', resource: {
  disabled_at?: string | null;
  paused_at?: string | null;
}) => {
  if (resource.paused_at) {
    return `The ${resource_name} is paused and will queue requests but not send them to the destination.`;
  }
  const action = resource_name === 'destination' ? 'send' : 'accept';
  if (resource.disabled_at) {
    return `The ${resource_name} is disabled and will not ${action} requests.`;
  }
  return `The ${resource_name} is active and is ${action}ing requests.`;
};
export const StatusBadge = t0 => {
  const $ = _c(9);
  let props;
  let resource;
  if ($[0] !== t0) {
    ({
      resource,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = resource;
  } else {
    props = $[1];
    resource = $[2];
  }
  if (resource.paused_at) {
    let t1;
    if ($[3] !== props) {
      t1 = <Badge warning={true} subtle={true} {...props}>Paused</Badge>;
      $[3] = props;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  if (resource.disabled_at) {
    let t1;
    if ($[5] !== props) {
      t1 = <Badge neutral={true} subtle={true} {...props}>Disabled</Badge>;
      $[5] = props;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    return t1;
  }
  let t1;
  if ($[7] !== props) {
    t1 = <Badge success={true} subtle={true} {...props}>Active</Badge>;
    $[7] = props;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
};